import { createContext, useContext, useState } from 'react'
import { useAuth, useView, userMode } from '@10000/react'
import { Avatar, Body, Box, Button, LeftArrow, MadeByPodAndHive, Progress } from '../widgets'
import { useStack } from './Stack.jsx'
import { Authenticate, SignUp } from '../auth'
import logo from '../../assets/logo.svg'
import { UserMenu } from '../'
import { SuperUserMenu } from '../super'
import { isFree } from '../../lookups'
import { query } from '../../utilities'
import './Shell.scss'

const { view } = query()

const context = createContext({})
export const useShell = options => useContext(context).configure(options)

export const Shell = ({ children }) => {
  const [mode, setMode] = useState('landing')
  const [max, setMax] = useState()
  const [step, setStep] = useState()
  const [footer, setFooter] = useState()
  const [onLogoClick, setOnLogoClick] = useState({})
  const [headerBackground, setHeaderBackground] = useState({})
  const [userMenuOpen, setUserMenuOpen] = useState(false)

  const { user: userType } = useAuth()
  const superMode = userType.super && userMode() === 'super'

  const { user, subscription } = useView('tenant')
  const { avatar } = user || { avatar: undefined }

  const { length, pop, push } = useStack()

  const configure = ({ active, mode, max, step, footer, onLogoClick, headerBackground }) => {
    if(active) {
      setTimeout(() => {
        setMode(mode)
        setMax(max)
        setStep(step)
        setFooter(footer)
        // you cannot store a function in state, wrap it in an object - maintain the same object if the callback matches to prevent render cycles
        setOnLogoClick(current => current.callback === onLogoClick ? current : { callback: onLogoClick })
        setHeaderBackground(headerBackground)
      })
    }
  }

  return (
    <context.Provider value={{ configure }}>
      <header
        className={mode}
        style={{
          background: headerBackground,
          backdropFilter: view === 'display' ? undefined : 'blur(5px)'
        }}
      >
        <Box className="components">
          <Box
            className="back"
            opacity={length === 1 ? 0 : undefined}
            onClick={() => {
              if(length > 1) {
                pop()
              }
            }}
          >
            <LeftArrow size={24} />
            <Body alt weight={600} underline>BACK</Body>
          </Box>
          <Box
            className="logo"
            onClick={() => onLogoClick.callback?.()}
            cursor={onLogoClick.callback ? 'pointer' : 'default'}
          >
            <img src={logo} alt="logo" />
          </Box>
          <Box className="progress progress-text">
            <Body alt weight={600}>{step}/{max}</Body>
          </Box>
          {!isFree(subscription) &&
            <Box className="user">
              <Avatar size="smallest" index={avatar} onClick={() => setUserMenuOpen(true)} />
              {superMode
                ? <SuperUserMenu open={userMenuOpen} onClose={() => setUserMenuOpen(false)} />
                : <UserMenu open={userMenuOpen} onClose={() => setUserMenuOpen(false)} />
              }
            </Box>
          }
          <Box className="attribution">
            <MadeByPodAndHive />
          </Box>
          <Box className="login-button" gap={8}>
            <Button light onClick={() => push(Authenticate)}>Log in</Button>
            <Button onClick={() => push(SignUp)}>Sign up</Button>
          </Box>
        </Box>
        <Progress max={max} step={step} />
      </header>
      {superMode
        ? <SuperUserMenu open={userMenuOpen} onClose={() => setUserMenuOpen(false)} mobile />
        : <UserMenu open={userMenuOpen} onClose={() => setUserMenuOpen(false)} mobile />
      }
      {children}
      <footer className="desktop-only" style={{ opacity: footer ? 1 : 0, zIndex: footer ? 1 : -1 }}>
        <MadeByPodAndHive />
      </footer>
    </context.Provider>
  )
}